import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useItemCategoryData = ({
  mianURL = 'https://thehindutoday.com',
  endpoint,
  key,
  category_name,
  selectedCategory,
  selectedCountry,
  selectedLanguage,
  selectedState,
  selectedCity,
  enabled,
  featured
}) => {
  return useQuery({
    queryKey: [
      key,
      endpoint,
      category_name,
      selectedCategory,
      selectedCountry,
      selectedLanguage,
      selectedState,
      selectedCity,
      mianURL,
      featured
    ],
    queryFn: async () => {
       if (!enabled) return null;
      const res = await axios.get(
        `${mianURL}/api/v1/public/${endpoint}`,
        {
          params: {
            language: selectedLanguage,
            country: selectedCountry,
            state: selectedState,
            city: selectedCity,
            category: selectedCategory,
            itemcategory: category_name,
            ...(featured === 1 && { is_featured: 1 }),
          },
        }
      );
      return res.data;
    },
    enabled:enabled === true,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: 1000 * 60 * 60, // 1 hour
    cacheTime: 1000 * 60 * 60 * 6, // 6 hours
    // select:(res)=>{
    //   return res?.map((item)=>console.log(item))
    // }
  });
};
